import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantConfigService } from '../services/tenant-config.service';

/**
 * TenantApiKeyInterceptor
 *
 * Automatically injects the X-API-Key header for all HTTP requests
 * based on the current tenant (domain/subdomain).
 *
 * The API Key is dynamically resolved from TenantConfigService, which
 * maps the current hostname to the appropriate hospital configuration.
 *
 * Architecture:
 * - localhost → HMRS pre-prod API Key
 * - hmrs.tudominio.com → HMRS prod API Key
 * - hospitalb.tudominio.com → Hospital B prod API Key
 *
 * This interceptor runs before all HTTP requests and ensures that
 * the backend receives the correct API Key for multi-tenant authentication.
 */
@Injectable()
export class TenantApiKeyInterceptor implements HttpInterceptor {
  private readonly tenantConfig = inject(TenantConfigService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Get the API Key for the current tenant
    const apiKey = this.tenantConfig.getApiKey();

    // Clone the request and add the X-API-Key header
    const clonedReq = req.clone({
      setHeaders: {
        'X-API-Key': apiKey,
      },
    });

    return next.handle(clonedReq);
  }
}
